let divisions = require('@/biz/divisions/model/index')

const goodsArr1 = ['0001', '0004', '0302', '0303', '0310']

const goodsArr2 = ['0002', '0003', '0005', '8900']

const payConditionDetailArr = {
  payCondition1: {
    text1: '完了確認月末締当末日払い',
    text2: '完了確認月末締当"「支払予定日」"日払い',
  },
  payCondition2: {
    text1: '完了確認月末締翌末日払い',
    text2: '完了確認月末締翌"「支払予定日」"日払い',
  },
  payCondition3: {
    text1: '完了確認月末締翌々末日払い',
    text2: '完了確認月末締翌々"「支払予定日」"日払い',
  },
}

const reportFormatArr = [
  {
    value: divisions.reportFormatEnum.enum_1.value,
    text: '速報版',
  },
  {
    value: divisions.reportFormatEnum.enum_2.value,
    text: '正式版',
  },
]

const legalPostsendFlg = [
  {
    text: 'アップロード',
    value: divisions.boolFlagEnum.enum_1.value,
  },
  {
    text: '郵送',
    value: divisions.boolFlagEnum.enum_blank.value,
  },
]
//発注情報承認ステータス
const purchaseOrderStatus = {
  //承認前変更モード：発注情報承認前変更画面を表示する。
  // 発注ステータスが「700｣発注登録中、「801」発注登録保留中、「802」発注登録否決の場合 はい 承認前変更モード
  beforeApproval: [
    divisions.purchaseOrderStatusEnum.enum_700.value,
    divisions.purchaseOrderStatusEnum.enum_801.value,
    divisions.purchaseOrderStatusEnum.enum_802.value,
  ],
  //承認後変更モード：発注情報承認後変更画面を表示する。
  // 発注ステータスが「710｣発注変更中、「720｣発注キャンセル中、「811」発注変更保留中、「812」発注変更否決、「821」発注キャンセル保留中、「822」発注キャンセル否決の場合 はい 承認後変更モード
  afterApproval: [
    divisions.purchaseOrderStatusEnum.enum_710.value,
    divisions.purchaseOrderStatusEnum.enum_720.value,
    divisions.purchaseOrderStatusEnum.enum_811.value,
    divisions.purchaseOrderStatusEnum.enum_812.value,
    divisions.purchaseOrderStatusEnum.enum_821.value,
    divisions.purchaseOrderStatusEnum.enum_822.value,
  ],
  //発注編集制限
  editableLimit: [
    divisions.purchaseOrderStatusEnum.enum_800.value,
    divisions.purchaseOrderStatusEnum.enum_810.value,
    divisions.purchaseOrderStatusEnum.enum_820.value,
    divisions.purchaseOrderStatusEnum.enum_900.value,
    divisions.purchaseOrderStatusEnum.enum_920.value,
    divisions.purchaseOrderStatusEnum.enum_730.value,
  ],
  //発注ステータス 「700｣発注登録中、「710」発注変更中、「720」発注キャンセル中 '承認申請'ボタンの制限
  approvalApplicationLimit: [
    divisions.purchaseOrderStatusEnum.enum_700.value,
    divisions.purchaseOrderStatusEnum.enum_710.value,
    divisions.purchaseOrderStatusEnum.enum_720.value,
  ],
}

//発注書出力区分
const purchaseOrderOutputClassLimit = {
  //受託
  consignment: [
    divisions.purchaseOrderOutputClassEnum.enum_1.value,
    divisions.purchaseOrderOutputClassEnum.enum_9.value,
  ],

  //特定部門
  specificDepartment: [
    divisions.purchaseOrderOutputClassEnum.enum_J.value,
    divisions.purchaseOrderOutputClassEnum.enum_L.value,
    divisions.purchaseOrderOutputClassEnum.enum_N.value,
    divisions.purchaseOrderOutputClassEnum.enum_Y.value,
    divisions.purchaseOrderOutputClassEnum.enum_9.value,
  ],

  //ｵﾌｨｽﾌｧｼﾘﾃｨ部門
  officeFacilitiesDepartment: [
    divisions.purchaseOrderOutputClassEnum.enum_P.value,
    divisions.purchaseOrderOutputClassEnum.enum_9.value,
  ],
  //採用見積
  estimateApply: [
    divisions.purchaseOrderOutputClassEnum.enum_6.value,
    divisions.purchaseOrderOutputClassEnum.enum_G.value,
    divisions.purchaseOrderOutputClassEnum.enum_H.value,
    divisions.purchaseOrderOutputClassEnum.enum_W.value,
    divisions.purchaseOrderOutputClassEnum.enum_X.value,
  ],
  //発注先がECO連携
  ecoAlign: [
    divisions.purchaseOrderOutputClassEnum.enum_1.value,
    divisions.purchaseOrderOutputClassEnum.enum_2.value,
    divisions.purchaseOrderOutputClassEnum.enum_5.value,
    divisions.purchaseOrderOutputClassEnum.enum_6.value,
    divisions.purchaseOrderOutputClassEnum.enum_E.value,
    divisions.purchaseOrderOutputClassEnum.enum_F.value,
    divisions.purchaseOrderOutputClassEnum.enum_G.value,
    divisions.purchaseOrderOutputClassEnum.enum_H.value,
    divisions.purchaseOrderOutputClassEnum.enum_J.value,
    divisions.purchaseOrderOutputClassEnum.enum_L.value,
    divisions.purchaseOrderOutputClassEnum.enum_N.value,
    divisions.purchaseOrderOutputClassEnum.enum_P.value,
    divisions.purchaseOrderOutputClassEnum.enum_U.value,
    divisions.purchaseOrderOutputClassEnum.enum_V.value,
    divisions.purchaseOrderOutputClassEnum.enum_W.value,
    divisions.purchaseOrderOutputClassEnum.enum_X.value,
    divisions.purchaseOrderOutputClassEnum.enum_Y.value,
  ],
  //運搬指示書
  transportationInstructions: [
    divisions.purchaseOrderOutputClassEnum.enum_E.value,
    divisions.purchaseOrderOutputClassEnum.enum_F.value,
    divisions.purchaseOrderOutputClassEnum.enum_G.value,
    divisions.purchaseOrderOutputClassEnum.enum_H.value,
    divisions.purchaseOrderOutputClassEnum.enum_J.value,
    divisions.purchaseOrderOutputClassEnum.enum_U.value,
    divisions.purchaseOrderOutputClassEnum.enum_V.value,
    divisions.purchaseOrderOutputClassEnum.enum_W.value,
    divisions.purchaseOrderOutputClassEnum.enum_X.value,
    divisions.purchaseOrderOutputClassEnum.enum_Y.value,
  ],
}

const controlFileCtckeyFCPSTCD = 'FCPSTCD'
const controlFileCtckeyORDSPPST = 'ORDSPPST'

const accountingDepCdPosFE = 'FE'

const dateFormatYYYYMMDD = 'YYYY/MM/DD'

const dateFormatYYYYMMDDHHMM = 'YYYY/MM/DD HH:mm'

const dateFormatHHMMSSSSS = 'HH:mm:ss:SSS'

const dateFormatYYYYMM = 'YYYY/MM'

const dateFormatYYYY = 'YYYY'

const maxYearMonth = 36

//見積書様式区分---受託の場合
const estimateStyleClassListArr1 = [
  divisions.estimateStyleClassEnum.enum_1.value,
  divisions.estimateStyleClassEnum.enum_2.value,
]

//見積書様式区分---特定の商品CD(0200)・商品明細CD(644,646,647)が一つでも含まれている場合に、見積登録・変更では「災害マニュアル」の書式のみ選択可能となる。
const estimateStyleClassListArr2 = [
  divisions.estimateStyleClassEnum.enum_E.value,
]

//見積書様式区分---進行部門＝特殊部門 and 役務工事：特定工事ＣＤあり
const estimateStyleClassListArr3 = [
  divisions.estimateStyleClassEnum.enum_3.value,
  divisions.estimateStyleClassEnum.enum_A.value,
  divisions.estimateStyleClassEnum.enum_B.value,
  divisions.estimateStyleClassEnum.enum_C.value,
  divisions.estimateStyleClassEnum.enum_D.value,
]

//見積書様式区分---進行部門＝特殊部門 and 特定工事ＣＤなし
const estimateStyleClassListArr4 = [
  divisions.estimateStyleClassEnum.enum_2.value,
  divisions.estimateStyleClassEnum.enum_4.value,
  divisions.estimateStyleClassEnum.enum_5.value,
  divisions.estimateStyleClassEnum.enum_6.value,
  divisions.estimateStyleClassEnum.enum_7.value,
  divisions.estimateStyleClassEnum.enum_8.value,
]

//見積書様式区分---進行部門≠特殊部門 and 役務工事：特定工事ＣＤあり
const estimateStyleClassListArr5 = [
  divisions.estimateStyleClassEnum.enum_A.value,
  divisions.estimateStyleClassEnum.enum_B.value,
  divisions.estimateStyleClassEnum.enum_C.value,
  divisions.estimateStyleClassEnum.enum_D.value,
]

//見積書様式区分---進行部門≠特殊部門 and 営繕工事：特定工事ＣＤなし
const estimateStyleClassListArr6 = [
  divisions.estimateStyleClassEnum.enum_1.value,
  divisions.estimateStyleClassEnum.enum_2.value,
]

// 受注情報承認ステータス
const acceptOrderStatus = {
  beforeApproval: [
    divisions.acceptOrderStatusEnum.enum_300.value,
    divisions.acceptOrderStatusEnum.enum_320.value,
    divisions.acceptOrderStatusEnum.enum_110.value,
    divisions.acceptOrderStatusEnum.enum_211.value,
    divisions.acceptOrderStatusEnum.enum_212.value,
  ],
  afterApproval: [
    divisions.acceptOrderStatusEnum.enum_120.value,
    divisions.acceptOrderStatusEnum.enum_140.value,
    divisions.acceptOrderStatusEnum.enum_221.value,
    divisions.acceptOrderStatusEnum.enum_222.value,
    divisions.acceptOrderStatusEnum.enum_241.value,
    divisions.acceptOrderStatusEnum.enum_242.value,
  ],
}

// 発注書出力区分が「E｣建設業法、「F」建設業法＋納品報告、｢G」建業明細、「H」建業明細＋納品報告、「U」建設業法並記、「V」建設業法並記＋納品報告、「W」建業明細並記、「X」建業明細並記＋納品報告の場合
const purchaseOrderOutputClassLimitList1 = [
  divisions.purchaseOrderOutputClassEnum.enum_E.value,
  divisions.purchaseOrderOutputClassEnum.enum_F.value,
  divisions.purchaseOrderOutputClassEnum.enum_G.value,
  divisions.purchaseOrderOutputClassEnum.enum_H.value,
  divisions.purchaseOrderOutputClassEnum.enum_U.value,
  divisions.purchaseOrderOutputClassEnum.enum_V.value,
  divisions.purchaseOrderOutputClassEnum.enum_W.value,
  divisions.purchaseOrderOutputClassEnum.enum_X.value,
]
// 発注書出力区分が「J｣専門＋納品報告、「L」工事部役務・診断＋納品報告、｢N」タイル＋納品報告、「Y」evﾘﾆｭｰｱﾙ＋納品報告の場合
const purchaseOrderOutputClassLimitList2 = [
  divisions.purchaseOrderOutputClassEnum.enum_J.value,
  divisions.purchaseOrderOutputClassEnum.enum_L.value,
  divisions.purchaseOrderOutputClassEnum.enum_N.value,
  divisions.purchaseOrderOutputClassEnum.enum_Y.value,
]
// 発注書出力区分が「1｣連絡書or発注書ａ、「2」役務発注書、｢5」役務発注書＋納品報告、「6」役務明細＋納品報告、「P」移転・物販の場合、
const purchaseOrderOutputClassLimitList3 = [
  divisions.purchaseOrderOutputClassEnum.enum_1.value,
  divisions.purchaseOrderOutputClassEnum.enum_2.value,
  divisions.purchaseOrderOutputClassEnum.enum_5.value,
  divisions.purchaseOrderOutputClassEnum.enum_6.value,
  divisions.purchaseOrderOutputClassEnum.enum_P.value,
]
// 請求支払区分が「2｣支払、「3」請求兼支払、｢5」内製発注先の場合
const billPayClassLimitList1 = [
  divisions.billPayClassEnum.enum_2.value,
  divisions.billPayClassEnum.enum_3.value,
  divisions.billPayClassEnum.enum_5.value,
]
// 請求支払区分が「2｣支払、「3」請求兼支払の場合
const billPayClassLimitList2 = [
  divisions.billPayClassEnum.enum_2.value,
  divisions.billPayClassEnum.enum_3.value,
]

// 特定の商品CDの値
const specificProductsCd = [
  {
    name: '移転_ＤＨＧ',
    code: '0351',
  },
  {
    name: '移転_一般',
    mode: '0352',
  },
  {
    name: '営繕（クライアントサポート）',
    mode: '0353',
  },
  {
    name: '物販（クライアントサポート）',
    mode: '0359',
  },
]

// 特定の商品CDの値
const workScheduleProductsCd = [
  {
    name: '移転_ＤＨＧ',
    code: '0351',
  },
  {
    name: '移転_一般',
    mode: '0352',
  },
  {
    name: '建築・設備工事',
    mode: '0150',
  },
  {
    name: '計画修繕工事',
    mode: '0160',
  },
  {
    name: '物販（クライアントサポート）',
    mode: '0359',
  },
]

// "ブランク","C","S"から"G"への変更はエラー---status
const changeToGFlg = false

// "G"から"ブランク"への変更はエラー---status
const changeGToBlank = false

//発注情報編集可否ステータス
module.exports = {
  goodsArr1,
  goodsArr2,
  payConditionDetailArr,
  purchaseOrderStatus,
  controlFileCtckeyFCPSTCD,
  controlFileCtckeyORDSPPST,
  accountingDepCdPosFE,
  dateFormatYYYYMMDD,
  dateFormatYYYYMM,
  dateFormatYYYY,
  estimateStyleClassListArr1,
  estimateStyleClassListArr2,
  estimateStyleClassListArr3,
  estimateStyleClassListArr4,
  estimateStyleClassListArr5,
  estimateStyleClassListArr6,
  acceptOrderStatus,
  purchaseOrderOutputClassLimit,
  purchaseOrderOutputClassLimitList1,
  purchaseOrderOutputClassLimitList2,
  purchaseOrderOutputClassLimitList3,
  billPayClassLimitList1,
  billPayClassLimitList2,
  specificProductsCd,
  workScheduleProductsCd,
  changeToGFlg,
  changeGToBlank,
  maxYearMonth,
  dateFormatYYYYMMDDHHMM,
  reportFormatArr,
  legalPostsendFlg,
  dateFormatHHMMSSSSS,
}
